import { useRef, useState } from 'react'
import { QRCode } from 'react-qrcode-logo'
import ReactGA from 'react-ga4'

import { useAppSelector } from 'redux/hooks'

import ToastService from 'services/toast.service'

import PhatButton from 'components/formElements/PhatButton'
import PhatDropdown from 'components/formElements/PhatDropdown'

import { convertNameToURLSafeName } from 'utils/deckSeo'

import styles from './qrViewer.module.scss'

type Props = {
  link: string
  onCloseQrViewer: () => void
}

const DeckQRViewer = ({ link, onCloseQrViewer }: Props) => {
  const [qrType, setQrType] = useState<'qr-only' | 'card'>('qr-only')

  const qrRef = useRef<QRCode | null>(null)

  const deckName = useAppSelector(state => state.deck.name)
  const featured = useAppSelector(state => state.deck.featured)
  const customFeatured = useAppSelector(state => state.deck.customFeatured)
  const deckTags = useAppSelector(state => state.deck.deckTags)

  const handleDownloadQROnly = () => {
    ReactGA.event({ category: 'Share', action: 'Downloaded QR Code only' })

    try {
      qrRef.current?.download('png', `${convertNameToURLSafeName(deckName)}_qr_only.png`)
    } catch (e) {
      ToastService.create(`Unable to generate file: ${e}`, 'QR Code generator', 'error')
    }
  }

  return (
    <div>
      <div className={styles.controls}>
        <PhatButton icon="arrow left" onClick={() => onCloseQrViewer()}>
          Back to options
        </PhatButton>
        {/* <PhatDropdown
          value={qrType}
          options={[
            { id: 'qr-only', label: 'QR Code Only', onClick: () => setQrType('qr-only') },
            { id: 'card', label: 'Fancy QR Code', onClick: () => setQrType('card') },
          ]}
        /> */}
      </div>

      <div className={styles.container}>
        {qrType === 'qr-only' && (
          <>
            <QRCode
              ref={qrRef}
              size={256}
              value={link}
              logoImage="/images/logo.svg"
              logoWidth={64}
              logoHeight={64}
              logoPadding={4}
              qrStyle="dots"
              removeQrCodeBehindLogo
              style={{
                background: 'white',
                padding: '0.5rem',
                borderRadius: 8,
              }}
            />
            <PhatButton onClick={handleDownloadQROnly}>Download QR Code</PhatButton>
          </>
        )}

        {qrType === 'card' && (
          <div className={styles.card}>
            <div className={styles.titleBox}>{deckName}</div>

            <div className={styles.art}>
              <img src={customFeatured || featured} alt="Deck featured preview" />
            </div>

            <div className={styles.tags}>
              {deckTags.map(tag => tag.name).join(', ')}
              {!deckTags.length && <span className={styles.dimText}>No deck tags</span>}
            </div>

            <QRCode
              ref={qrRef}
              size={100}
              value={link}
              logoImage="/images/logo.svg"
              logoWidth={25}
              logoHeight={25}
              logoPadding={2}
              qrStyle="dots"
              removeQrCodeBehindLogo
              style={{
                background: 'white',
                borderRadius: 8,
              }}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default DeckQRViewer
